webpackJsonp([61756378260609],{

/***/ 1877:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"NovaBoardRowCells","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cells","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"NovaBoardCell","ofType":null}}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"sheetId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":"Cell statistics for a single NovaBoard sheet","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-nova-board-row-cells-ee125f0a389b506b2c17.js